import React, { useCallback } from "react";
import List from "@commonComponents/List";
import EconomicOperatorForm from "@EUForms/economicOperatorForm";
import { Grid } from "semantic-ui-react";
import InputField from "@commonComponents/formComponents/CustomInputField";

const EconomicOperatorDetail = ({dataSource,updateContactInfo,countryList,...rest}) => {

      const renderAtLast=useCallback(({dataSource,tableName,onBlur})=>{
      const onChangeHandler=({target:{value,name}})=>updateContactInfo(dataSource.id,tableName,{[name]:value})
      const saveContactInfo=({target:{value,name}})=>onBlur(tableName,{contact:{[name]:value},id:dataSource.id})
      
    return(
     <>
      <Grid.Column>
     <InputField
           id={`contactName${dataSource.id}`}
           isLabel={false}
           type='text'
           name="name"
           label="CONTACT_NAME"
           onChange={onChangeHandler}
           onBlur={saveContactInfo}
           value={dataSource?.contact?.name}
           />
     </Grid.Column>
     <Grid.Column>
     <InputField
           id={`phoneNumber${dataSource.id}`}
           isLabel={false}
           name="phone"
           type='number'
           label="PHONE_NUMBER"
           onChange={onChangeHandler}
           onBlur={saveContactInfo}
           value={dataSource?.contact?.phone}
           />
     </Grid.Column>
     <Grid.Column>
     <InputField
           id={`email${dataSource.id}`}
           name="email"
           isLabel={false}
           type='text'
           label="EMAIL_ADDRESS"
           onChange={onChangeHandler}
           onBlur={saveContactInfo}
           value={dataSource?.contact?.email}
          
           />
     </Grid.Column>
     </>
    )
 },[updateContactInfo])
  const renderItem=useCallback((item)=> <EconomicOperatorForm 
  dataSource={item} 
  key={item.id}  
  renderAtLast={renderAtLast}
  countryList={countryList}
  {...rest}
   />,[renderAtLast,countryList,rest]
)

  
  return <List className="responsiveGridCss"  dataSource={dataSource} renderItem={renderItem}
/>
}

export default React.memo(EconomicOperatorDetail)
